import { DraftBendingTextConfiguration } from '@/types';
import { nanoid } from '@/utils/nanoid';
import { SVG_NS, XLINK_NS, XMLNS_NS } from './consts';
import { getTextPathShape } from './getTextPathShape';

export function renderBendingText(draftConfiguration: DraftBendingTextConfiguration) {
  const { printColors, size, text } = draftConfiguration;
  const textStyle = text.style;
  const { width, height } = size;
  const docType = '<!DOCTYPE svg [ <!ENTITY nbsp " &#160;">] >';

  const svg = document.createElementNS(SVG_NS, 'svg');
  svg.setAttributeNS(XMLNS_NS, 'xmlns:xlink', XLINK_NS);
  svg.setAttributeNS(XMLNS_NS, 'xmlns', SVG_NS);
  svg.setAttribute('fill', printColors[0].fill);
  svg.setAttribute('version', '1.2');
  svg.setAttribute('width', `${width}mm`);
  svg.setAttribute('viewBox', `0 0 ${width} ${height}`);

  const pathId = nanoid();
  const path = document.createElementNS(SVG_NS, 'path');
  path.setAttribute('id', pathId);
  path.setAttribute('fill', 'none');
  path.setAttribute('d', getTextPathShape(textStyle.angle));
  svg.appendChild(path);

  const textElement = document.createElementNS(SVG_NS, 'text');
  textElement.setAttribute('font-family', textStyle.font.identifier);
  textElement.setAttribute('font-size', String(textStyle.fontSize));
  textElement.setAttribute('text-anchor', 'middle');
  textElement.setAttribute('dy', textStyle.angle < 0 ? '16' : '0');
  svg.appendChild(textElement);

  const textPath = document.createElementNS(SVG_NS, 'textPath');
  textPath.setAttributeNS(XLINK_NS, 'xlink:href', `#${pathId}`);
  textPath.setAttribute('startOffset', '50%');
  textPath.textContent = text.content.replace(/\r\n|\r|\n/g, ' ');
  textElement.appendChild(textPath);

  document.body.appendChild(svg);

  const textBBox = textElement.getBBox();
  const pathBBox = path.getBBox();
  const textPathBBox = (textPath.parentNode as SVGSVGElement).getBBox();

  const offset = {
    x: (textPathBBox.width - pathBBox.width) * 0.5,
    y: -textBBox.y,
  };
  path.setAttribute('transform', `translate(${offset.x}, ${offset.y})`);

  const svgText = svg.outerHTML;
  document.body.removeChild(svg);
  return docType + svgText;
}
